export default __webpack_public_path__ + "static/media/youtubeDeskFill.3946bc58.svg";